import React from 'react'

import { TPublicAccount } from 'shopify-payments-types'

export type TAuthContext = {
  account: TPublicAccount
  shopAdminUrl: string
  shopGatewayUrl: string
  refreshAccount(): Promise<TPublicAccount>
}

const context = React.createContext<TAuthContext | null>(null)

export const AuthProvider = context.Provider

export function useAuth(silent = false) {
  const auth = React.useContext(context)
  if (!auth && !silent) {
    throw new Error("Called useAuth before it's set")
  }
  return auth!
}
